import type { FunctionComponent, ReactNode } from 'react';

import classNames from 'classnames';

import styles from './metadata_field_separator.module.css';

type Props = {
  content?: ReactNode;
  lineHeight?: number;
  lineClassName?: string;
  labelPosition?: 'left' | 'center';
};

const Separator: FunctionComponent<Props> = ({
  content,
  lineClassName,
  lineHeight = 2,
  labelPosition = 'center',
}) => (
  <div className={styles.wrapper}>
    {content ? (
      <>
        <div
          style={{ height: `${lineHeight}px`, width: 12 }}
          className={classNames(
            styles.line,
            lineClassName,
            labelPosition === 'left' && styles.left,
          )}
        />
        <div className={styles.content}>{content}</div>
        <div
          style={{ height: `${lineHeight}px` }}
          className={classNames(styles.line, lineClassName)}
        />
      </>
    ) : (
      <div
        style={{ height: `${lineHeight}px` }}
        className={classNames(styles.line, lineClassName)}
      />
    )}
  </div>
);

export default Separator;
